import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Spin,
  Table,
  Button,
} from "antd";
import Title from "antd/lib/typography/Title";
import { useDispatch, useSelector } from "react-redux";
import {  fetchCustomer } from "../../../actions/actionCustomer";
import { actHideLoading, actShowLoading } from "../../../actions/actionLoading";
import {
  EditOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import {
  FetchURL,
} from "../../../util/help";
import SearchComponent from "../../../Component/SearchComponent";

function Customer() {
  const [search, setSearch] = useState({ type: "", keyword: "" });

  const customer = useSelector((state) => state.customer);
  const isLoading = useSelector((state) => state.isLoading);

  const dispatch = useDispatch();
  const getCustomer = (data) => dispatch(fetchCustomer(data));
  const showLoading = () => dispatch(actShowLoading());
  const hideLoading = () => dispatch(actHideLoading());

  useEffect(() => {
    onChangePage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.keyword]);

  const onChangePage = (page) => {
    var newPage = 1;
    var url = "";
    if (page) {
      newPage = page;
    }
    if (search.keyword) {
      url = `data-basic/customer/search/group=customer&type=${search.type}&value=${search.keyword}&page=${newPage}`;
    } else {
      url = `data-basic/customer/type=1`;
    }
    showLoading();
    fetch(FetchURL + url)
      .then((res) => res.json())
      .then((data) => {
        if (data.success === true) {
          getCustomer(data.data);
          hideLoading();
        }
      })
      .catch((err) => console.log(err));
  };

  // const Delete = (CUST_NO, CUST_NAME) => {
  //   var params = {
  //     CUST_NO: CUST_NO,
  //     CUST_TYPE: 1,
  //   };
  //   showLoading();
  //   axios
  //     .post("data-basic/customer/remove", addFormData(params))
  //     .then((res) => {
  //       if (res.status === 200) {
  //         if (res.data.success === true) {
  //           DeleteCustomer(CUST_NO);
  //           hideLoading();
  //           openNotificationWithIcon(
  //             "success",
  //             `Bạn đã Delete thành công ${CUST_NAME}`
  //           );
  //         }
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };

  const columns = [
    {
      title: "Cust No",
      dataIndex: "CUST_NO",
      key: "CUST_NO",
    },
    {
      title: "Name",
      dataIndex: "CUST_NAME",
      key: "CUST_NAME",
    },
    {
      title: "Address",
      dataIndex: "CUST_ADDRESS",
      key: "CUST_ADDRESS",
    },
    {
      title: "Tax",
      dataIndex: "CUST_TAX",
      key: "CUST_TAX",
    },
    {
      title: "Phone",
      dataIndex: "CUST_TEL1",
      key: "CUST_TEL1",
    },
    {
      title: "Input",
      dataIndex: "INPUT_USER",
      key: "INPUT_USER",
    },
    {
      title: "Date",
      dataIndex: "INPUT_DT",
      key: "INPUT_DT",
    },
    {
      title: "Edit",
      dataIndex: "MODIFY_USER",
      key: "MODIFY_USER",
    },
    {
      title: "Date Edit",
      dataIndex: "MODIFY_DT",
      key: "MODIFY_DT",
    },
    {
      render: (text, record) => (
        <>
          <Link to={`/Dasboard/khachhang/edit/${record.CUST_NO}`}>
            <Button
              type="primary"
              style={{
                backgroundColor: "#faad14",
                borderColor: "#faad14",
                marginRight: 20,
              }}
              icon={<EditOutlined />}
            >
              <span style={{ marginLeft: 8, color: "white" }}>Edit</span>
            </Button>
          </Link>

          {/* <Popconfirm
            title="Bạn có chắn chắn Delete?"
            onConfirm={() => Delete(record.CUST_NO, record.CUST_NAME)}
          >
            <Button type="primary" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm> */}
        </>
      ),
    },
  ];
  function onSearch(values) {
    setSearch({
      type: values.type,
      keyword: values.keyword,
    });
  }

  return (
    <Spin size="large" spinning={isLoading}>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>BASICAL DATA</Breadcrumb.Item>
        <Breadcrumb.Item>Customers</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <div style={{ textAlign: "center" }}>
          <Title style={{ color: "#1890ff" }}>Customers</Title>
        </div>
        <SearchComponent name='customer' onSearch={onSearch}/>
        <Button type="primary" style={{ marginBottom: 20 }}>
          <Link to="/Dasboard/khachhang/create">Create</Link>
        </Button>

        <Table
          dataSource={customer}
          columns={columns}
          rowKey={columns[0].key.toString()}
          pagination={{ position: ["bottomLeft"] }}
          size="small"
        />
      </div>
    </Spin>
  );
}

export default Customer;
